import { render, staticRenderFns } from "./Cabina.vue?vue&type=template&id=3ab37d84&scoped=true&"
import script from "./Cabina.vue?vue&type=script&lang=js&"
export * from "./Cabina.vue?vue&type=script&lang=js&"
import style0 from "./Cabina.vue?vue&type=style&index=0&id=3ab37d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab37d84",
  null
  
)

export default component.exports